import React from 'react';

function Team() {
    return (
          <div className="Container p-5">
      <div className="row border-top ">
        <h2 className="fs-3 pt-3 pb-0 text-center">
                People
        </h2>   
      </div>
       <div className="row p-5 mt-5 border-top  text-muted"
       style={{fontSize:"1.2em" , lineHeight:"1.8em"}}>
        <div className="col-6 mt-5 text-center">
          <img src='media/images/nithinKamath.jpg' alt='nitin' style={{width:"45%" , borderRadius:"100%"}}/>
        </div>
        <div className="col-6 p-5">
           <p>Nithin bootstrapped and founded Zerodha in 2010 to overcome the hurdles he faced during his decade long stint as a trader. Today, Zerodha has changed the landscape of the Indian broking industry.</p>

<p>He is a member of the SEBI Secondary Market Advisory Committee (SMAC) and the Market Data Advisory Committee (MDAC).</p>

<p>Playing basketball is his zen.</p>

<p>Connect on Homepage / TradingQnA / Twitter</p>
        </div>
      </div>
    </div> 
    );
}

export default Team;